export default `p = asin( sin( p ) ) - vec3( 2., -3., 0. );
  float e=0., s=2.;
  for(int i=0;i++<8;p=p*e-vec3(1.0,3.0,7.0))
    p=abs(p),
    p=p.x<p.y?p.zxy:p.zyx,
    s*=e=2./clamp(dot(p,p),.2,1.);
  return e=abs(length(p-clamp(p,-5.,5.))-5.)/s+1e-5;
}`